import * as React from 'react';

type FragmentProps = {
    children: Array<React.ReactNode>
};

class Fragment extends React.Component<FragmentProps, {}> {
    render() {
        return this.props.children;
    }
}

export default Fragment;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/fragment.tsx